import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=ff8597cc&scoped=true&"
import script from "./Landing.vue?vue&type=script&lang=ts&"
export * from "./Landing.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/css/landing.css?vue&type=style&index=0&id=ff8597cc&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/bootstrap.css?vue&type=style&index=1&id=ff8597cc&prod&scoped=true&lang=css&"
import style2 from "@/assets/fonts/icon-font/css/style.css?vue&type=style&index=2&id=ff8597cc&prod&scoped=true&lang=css&"
import style3 from "@/assets/fonts/typography-font/typo.css?vue&type=style&index=3&id=ff8597cc&prod&scoped=true&lang=css&"
import style4 from "@/assets/fonts/fontawesome-5/css/all.css?vue&type=style&index=4&id=ff8597cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8597cc",
  null
  
)

export default component.exports